import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { cleanReducerOnPageChange } from '../utils'

const KEY = "forwalkMonitorUserPosition"

const getInitialState = () => ({
  monitorUserPosition: window.sessionStorage.getItem(Boolean(KEY)),
  userPosition: null,
})

const initialState = getInitialState() 

const userPositionSlice = createSlice({
  name: 'userposition',
  initialState,
  reducers: {
    setUserPosition(state, action) {
        state.userPosition = action.payload
    },
    setMonitorUserPosition(state, action){
        state.monitorUserPosition = action.payload
        sessionStorage.setItem(KEY, action.payload ? 1 : 0)
    }
  },
  extraReducers: (builder) => cleanReducerOnPageChange(builder, getInitialState)
})


export const useUserPosition = () => useSelector( state => state.userposition.monitorUserPosition ? state.userposition.userPosition : null),
             useUserIsNearTrail = () => useSelector( state => !!state.userposition.userPosition ),
             useUserIsOnTrail = () => useSelector( state => state.userposition.userPosition && state.userposition.userPosition.distanceFromTrail < 50),
             useUserPositionOnTrailIsReached = (length) => useSelector( state => state.userposition.monitorUserPosition && state.userposition.userPosition && state.userposition.userPosition.distanceFromTrail < 50 && state.userposition.userPosition.distance > length),
             useMonitorUserPosition = () => useSelector( state => state.userposition.monitorUserPosition )

export const { setUserPosition, setMonitorUserPosition } = userPositionSlice.actions
export default userPositionSlice
